<script setup lang="ts">
import { toRef, reactive } from 'vue';
import { useTab } from '@/composables/tabs';

interface Props {
  name : string;
}

const props = defineProps<Props>();
const name = toRef(props, 'name');
const tabData = reactive({ name });
const { isActive } = useTab(tabData);

</script>

<template>
  <div
    v-show="isActive"
  >
    <slot></slot>
  </div>
</template>
